<template>
  <div class="shine-loading" :style="[
    body_width && `width: ${body_width}px`,
    body_height && `height: ${body_height}px`,
  ]">
    <div
      class="line tw-my-1"
      :class="[
        size === 'sm' && 'sm',
        classLine
      ]"
      :style="[
        height && 'height: ' + height,
        width && 'width: ' + (width.toString().includes('px') ? width : (width + '%')),
      ]"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'ShineLoading',
  props: {
    size: {
      type: String,
      default: 'sm',
    },
    width: {
      type: [Number, String],
      default: 100,
    },
    height: {
      type: [Number, String],
      default: null ,
    },
    body_width: {
      type: Number,
      default: null,
    },
    body_height: {
      type: Number,
      default: null,
    },
    classLine: {
      type: String,
      default: null
    }
  },
}
</script>

<style scoped></style>
